__turbopack_context__.v({
  "className": "cormorant_garamond_b3655b23-module__yeadPq__className",
});
